import React, {useMemo} from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Conditional, Radio, Services, Switch } from '../../Components/Form';
import { useDocument } from '../../Data/Documents';

const VisibilityOptions = ({isOpen, setIsOpen, documentId}) => {
    return <Modal title="Share settings" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {documentId && <Inner documentId={documentId} />}
    </Modal>
}

const Inner = ({documentId}) => {
    const {document, updateVisibilityOptions} = useDocument(documentId);

    const data = useMemo(() => {
        if (!document) {
            return null;
        }
        const services = document?.visibilityOptions?.services ?? [];
        const data = {
            id: document.id,
            selectedServices: [],
            showOnWebsite: document?.visibilityOptions?.showOnWebsite ?? false,
        };

        if (services && services.includes('*')) {
            data.serviceOptions = 'All';
        } else if (!services || services.length === 0) {
            data.serviceOptions = 'None';
        } else {
            data.serviceOptions = 'Select';
            data.selectedServices = services;
        }
        return data;
    }, [document]);

    const handleSave = (data) => {
        console.log('handleSave', data)
        if (data.serviceOptions === 'None') {
            data.services = null;
        } else if (data.serviceOptions === 'All') {
            data.services = ['*'];
        } else if (data.serviceOptions === 'Select') {
            data.services = data.selectedServices;
        }

        return updateVisibilityOptions(data);
    }

    return <Form data={data} onSubmit={handleSave} waitForData closeModalOnSubmit>
        <Radio name="serviceOptions"
            label="Share with services"
            layout="SmallCards"
            options={[
                {label: 'None', value: 'None'},
                {label: 'All', value: 'All'},
                {label: 'Select', value: 'Select'},
            ]}
            help={v => {
                const helps = {
                    'None': 'This document will not be automatically included in any invoices or cost breakdowns.',
                    'All': 'This document will be automatically included in all invoices or cost breakdowns.',
                    'Select': 'This document will be automatically included in invoices and cost breakdowns which include the selected services.',
                }
                return helps[v] ?? null;
            }}
        />
        <Conditional condition={data => data.serviceOptions === 'Select'}>
            <Services name="selectedServices" label="Services" />
        </Conditional>
        <Switch name="showOnWebsite"
            label="Share on website"
            help="Share this document on your getSoapy website, or on your own website using the Documents Widget"
        />
        <Actions submit={{label: 'Save'}} cancel />
    </Form>
}

export default VisibilityOptions;
